export default function JuzSubmitPage() {
    return <h3>JuzSubmitPage</h3>
}